import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography, Button, Alert } from '@mui/material';
import Navbar from '../components/Navbar.js';
import { ENDPOINTS, apiCall } from '../utils/api.js';

// Consumes a booking-invite link (/join/:token): resolves the target queue + prefill phone,
// then lands the customer on the right booking page with their number pre-filled.
export default function JoinPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      try {
        const d = await apiCall(ENDPOINTS.INVITE_CONSUME(token));
        const org = d.organization_slug;
        let path = `/org/${org}`;
        if (d.category_slug) path = `/org/${org}/category/${d.category_slug}?open=1`;
        else if (d.facade_slug) path = `/org/${org}/facade/${d.facade_slug}`;
        // The phone rides in navigation state so it prefills the login/OTP without hitting the URL.
        navigate(path, { replace: true, state: { prefillPhone: d.phone || '' } });
      } catch (e) {
        setError(e.message || 'This link is invalid or has expired.');
      }
    })();
  }, [token, navigate]);

  if (error) {
    return (
      <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
        <Navbar />
        <Box sx={{ maxWidth: 480, mx: 'auto', px: 2, py: 10, textAlign: 'center' }}>
          <Alert severity="error" sx={{ borderRadius: 2, mb: 2 }}>{error}</Alert>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Join links expire after a while. You can still find the business and join its queue.
          </Typography>
          <Button variant="contained" onClick={() => navigate('/')}>Browse businesses</Button>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
      <Box sx={{ textAlign: 'center' }}>
        <CircularProgress />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>Getting you in line…</Typography>
      </Box>
    </Box>
  );
}
